module.exports = __webpack_public_path__ + "img/huayi-content.cb7ad6d9.png";